import Avatar from "Components/Base/DataDisplay/Avatar";
import styled from "styled-components";

const GameBadge = styled(Avatar)`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: pointer;
  margin: 0.7rem;
`;

export default GameBadge;
